import { AnyAction } from 'redux'
export const ADD_DEBUG_API_CALL = 'ADD_DEBUG_API_CALL'

export const addDebugApiCall = (apiCallData: Gallery.ApiResponseWithMetadata.ApiResponse): AnyAction => ({
  type: ADD_DEBUG_API_CALL,
  payload: apiCallData,
})
